import React from "react";
import MainTable from "../../components/main/MainTable";
import FilterMT from "../../components/contents/home/FilterMT";
import {connect} from "react-redux";
import {fetchResults} from "../../redux/actions/resultActions";

const FilterPage = ({...props}) => {
    return (
        <div id="dnw-page">
            <div id="dnw-main">
                <div className="dnw-sheet">
                    <MainTable>
                        <FilterMT {...props} />
                    </MainTable>
                </div>
            </div>
        </div>
    );
};

export default connect(null, {fetchResults})(FilterPage);
